import { createMotionProxy } from "./motion-proxy.js";
import { createDomMotionConfig } from "./utils/create-config.js";
import { gestureAnimations } from "../../motion/features/gestures.js";
import { animations } from "../../motion/features/animations.js";
import { drag } from "../../motion/features/drag.js";
import { createDomVisualElement } from "./create-visual-element.js";
import { layout } from "../../motion/features/layout.js";
const preloadedFeatures = {
  ...animations,
  ...gestureAnimations,
  ...drag,
  ...layout
};
const motion = /* @__PURE__ */ createMotionProxy((Component, config) => createDomMotionConfig(Component, config, preloadedFeatures, createDomVisualElement));
export {
  motion
};
//# sourceMappingURL=motion.js.map
